/** @jsx jsx */
import { jsx } from '@emotion/react';

import {
  AIGenerateIcon,
  ArtIcon,
  BriefcaseIcon,
  CodeIcon,
  GlobeIcon,
  HealthIcon,
  LaptopIcon,
  LaunchIcon,
  MathIcon,
  MembersIcon,
  ScienceIcon,
  TrendingIcon,
} from '@coursera/cds-icons';

import type { Domain } from 'bundles/unified-common/types/domain';

type Props = {
  domain: Domain;
  [`aria-hidden`]?: boolean;
};

const DomainIconComponent = ({ domain, ['aria-hidden']: ariaHidden }: Props) => {
  // aria-labelledby has precedence over all hidden and disabled aria properties.
  // We need to override this in cds icons in order for SRs to respect not reading the value.
  const ariaOverride = ariaHidden ? { 'aria-labelledby': undefined } : {};

  switch (domain.id) {
    case 'artificial-intelligence':
      return <AIGenerateIcon desc={domain.name} {...ariaOverride} />;
    case 'arts-and-humanities':
      return <ArtIcon desc={domain.name} {...ariaOverride} />;
    case 'business':
      return <BriefcaseIcon desc={domain.name} {...ariaOverride} />;
    case 'computer-science':
      return <CodeIcon desc={domain.name} {...ariaOverride} />;
    case 'data-science':
      return <TrendingIcon desc={domain.name} {...ariaOverride} />;
    case 'information-technology':
      return <LaptopIcon desc={domain.name} {...ariaOverride} />;
    case 'health':
      return <HealthIcon desc={domain.name} {...ariaOverride} />;
    case 'math-and-logic':
      return <MathIcon desc={domain.name} {...ariaOverride} />;
    case 'personal-development':
      return <LaunchIcon desc={domain.name} {...ariaOverride} />;
    case 'physical-science-and-engineering':
      return <ScienceIcon desc={domain.name} {...ariaOverride} />;
    case 'social-sciences':
      return <MembersIcon desc={domain.name} {...ariaOverride} />;
    case 'language-learning':
      return <GlobeIcon desc={domain.name} {...ariaOverride} />;
    default:
      return null;
  }
};

export default DomainIconComponent;
